import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Pie } from 'react-chartjs-2';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { getSuperAdminDashboardData } from '../../../redux/MainAction';
import { Card, CardBody, CardTitle, Row, Col, Button } from 'reactstrap';
import {
  FaUsers,
  FaComments,
  FaEnvelope,
  FaPhone,
  FaUser,
  FaBuilding,
  FaIdCard,
  FaGlobe,
  FaCalendarAlt,
} from 'react-icons/fa';
import DashboardClock from './DashboardClock';
import './Dashboard.css';

const SuperAdminDashboard = () => {
  const dispatch = useDispatch();
  const domainDetails = JSON.parse(localStorage.getItem('domainDetails'));
  const dashboardData = useSelector(
    (state) => state?.Webtracker?.adminDashboardData
  );

  useEffect(() => {
    dispatch(getSuperAdminDashboardData());
  }, [dispatch]);

  const pieData = {
    labels: ['Active', 'Inactive'],
    datasets: [
      {
        data: [
          dashboardData?.userCount?.active,
          dashboardData?.userCount?.inactive,
        ],
        backgroundColor: ['#36A2EB', '#FF6384'],
        hoverBackgroundColor: ['#36A2EB', '#FF6384'],
      },
    ],
  };

  return (
    <div className="page-content-wrapper">
      <div className="container-fluid">
        <div
          style={{
            marginLeft: '13px',
            fontSize: '22px',
            color: 'black',
            marginTop: '22px',
            marginBottom: '27px',
          }}
        >
          <h2
            className="col-12 text-capitalize font-600 m-0"
            style={{ letterSpacing: '0.15rem' }}
          >
            Welcome, Super Admin
          </h2>
        </div>

        <Row className="d-flex">
          <Col lg={6} sm={12} className="mb-4 d-flex">
            <Card className="w-100 d-flex flex-column enhanced-card">
              <CardBody className="d-flex flex-column flex-grow-1">
                <CardTitle tag="h5">Domain Details</CardTitle>
                <div className="d-flex justify-content-between align-items-center flex-grow-1">
                  <div className="d-flex flex-column">
                    <p className="text-capitalize">
                      <FaBuilding className="mr-2" />{' '}
                      <span className="font-weight-bold">Organization: </span>
                      {domainDetails?.organisationName}
                    </p>
                    <p className="text-capitalize">
                      <FaGlobe className="mr-2" />{' '}
                      <span className="font-weight-bold">Domain: </span>
                      {domainDetails?.domainName}
                    </p>
                    <p className="text-capitalize">
                      <FaUser className="mr-2" />{' '}
                      <span className="font-weight-bold">Contact: </span>
                      {domainDetails?.contactPerson}
                    </p>
                    <p className="text-capitalize">
                      <FaIdCard className="mr-2" />{' '}
                      <span className="font-weight-bold">Designation: </span>
                      {domainDetails?.designation}
                    </p>
                    <p>
                      <FaEnvelope className="mr-2" />{' '}
                      <span className="font-weight-bold">Email: </span>
                      {domainDetails?.email}
                    </p>
                    <p>
                      <FaPhone className="mr-2" />{' '}
                      <span className="font-weight-bold">Phone: </span>{' '}
                      {domainDetails?.phone}
                    </p>
                  </div>

                  <div className="text-center">
                    <DashboardClock />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>

          <Col lg={6} sm={12} className="mb-4 d-flex">
            <Card className="w-100 d-flex flex-column enhanced-card">
              <CardBody className="d-flex flex-column flex-grow-1">
                <CardTitle tag="h5">User Statistics</CardTitle>
                <div className="d-flex flex-column justify-content-center align-items-center flex-grow-1">
                  <div
                    style={{
                      position: 'relative',
                      width: '100%',
                      maxHeight: '200px',
                    }}
                  >
                    <Pie
                      data={pieData}
                      options={{
                        plugins: {
                          legend: {
                            position: 'top',
                            labels: {
                              boxWidth: 10,
                              usePointStyle: true,
                            },
                          },
                        },
                      }}
                      style={{ margin: 'auto' }}
                    />
                  </div>
                  <div className="mt-3 text-center">
                    <p>Total Users: {dashboardData?.userCount?.total}</p>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row className="d-flex">
          <Col lg={6} sm={12} className="mb-4 d-flex">
            <Card className="w-100 d-flex flex-column enhanced-card">
              <CardBody className="d-flex flex-column flex-grow-1">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <CardTitle tag="h5">
                    <FaUsers className="mr-2" /> User List
                  </CardTitle>
                  <Button tag={Link} to="/domains" color="primary" size="sm">
                    Show All
                  </Button>
                </div>
                <ul className="list-group flex-grow-1 overflow-auto">
                  {dashboardData?.userList?.slice(0, 5).map((user) => (
                    <li
                      key={user?.id}
                      className="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <strong>
                          {user?.firstName} {user?.lastName}
                        </strong>
                        <p className="mb-0 text-muted">{user?.email}</p>
                      </div>
                      <span
                        className={`badge badge-${user?.status === 'ACTIVE' ? 'success' : 'danger'} badge-pill`}
                      >
                        {user?.status}
                      </span>
                    </li>
                  ))}
                </ul>
              </CardBody>
            </Card>
          </Col>

          <Col lg={6} sm={12} className="mb-4 d-flex">
            <Card className="w-100 d-flex flex-column enhanced-card">
              <CardBody className="d-flex flex-column flex-grow-1">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <CardTitle tag="h5">
                    <FaComments className="mr-2" /> Recent Chats
                  </CardTitle>
                  <Button tag={Link} to="/chats" color="primary" size="sm">
                    Show All
                  </Button>
                </div>
                <ul className="list-group flex-grow-1 overflow-auto">
                  {dashboardData?.domainChatMessages
                    ?.slice(0, 4)
                    .map((chat) => (
                      <li key={chat.id} className="list-group-item">
                        <strong>
                          {chat?.user?.firstName} {chat?.user?.lastName}
                        </strong>
                        <p
                          className="mb-0 text-truncate"
                          style={{ maxWidth: '100%' }}
                        >
                          {chat?.message}
                        </p>
                        <small className="text-muted">
                          {moment(chat?.createdAt).format(
                            'MMM D, YYYY hh:mm A'
                          )}
                        </small>
                      </li>
                    ))}
                </ul>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SuperAdminDashboard;
